import { render } from "./RotateArrow.vue?vue&type=template&id=70dba09d&scoped=true"
import script from "./RotateArrow.vue?vue&type=script&lang=js"
export * from "./RotateArrow.vue?vue&type=script&lang=js"

import "./RotateArrow.vue?vue&type=style&index=0&id=70dba09d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70dba09d"]])

export default __exports__